import clsx from 'clsx';
import React from 'react';

import { useWindowScrolling } from '#/shared/hooks/useWindowScrolling';
import { isVisibleInViewport } from '#/shared/utils/domHelper';

import { Button } from './Button';

type FixedButtonProps = React.ComponentProps<typeof Button> & {
  wrapperTestId?: string;
};

export function FixedButton({ className, wrapperTestId, ...buttonProps }: FixedButtonProps) {
  const buttonAnchorRef = React.useRef<HTMLDivElement>(null);
  const [isButtonFixed, setIsButtonFixed] = React.useState<boolean>(true);

  const handleScroll = React.useCallback(() => {
    setIsButtonFixed(!isVisibleInViewport(buttonAnchorRef.current));
  }, []);

  useWindowScrolling({ onScroll: handleScroll });
  return (
    <>
      <div ref={buttonAnchorRef} />
      <div
        data-testid={wrapperTestId}
        className={
          isButtonFixed
            ? 'max-tablet-portrait:fixed bottom-0 right-0 left-0 bg-surface-l0 max-tablet-portrait:p-16'
            : ''
        }
      >
        <Button {...buttonProps} className={clsx('w-full', className)} />
      </div>
    </>
  );
}
